import { Box, Bones, Button } from '@simplywallst/ui-core';
import { Tile } from '@/components/TileNew';

export const LoadingSkeleton = () => (
  <Box boxShadow="softShadow" borderRadius="x1">
    <Tile>
      <Box
        height="162px"
        overflow="hidden"
        width="100%"
        backgroundColor="lightGray"
      >
        <Box width="50%" padding="x3">
          <Bones borderRadius="x1" backgroundColor="black" margin="x1" />
          <Bones borderRadius="x1" backgroundColor="black" margin="x1" />
          <Bones borderRadius="x1" backgroundColor="black" margin="x1" />
          <Bones borderRadius="x1" backgroundColor="black" margin="x1" />
        </Box>
      </Box>
      <Box
        width="100%"
        height="396px"
        paddingTop="x3"
        paddingLeft="x3"
        paddingRight="x5"
        backgroundColor="white"
      >
        <Box>
          <Bones borderRadius="x1" backgroundColor="black" marginTop="x2" />
          <Bones borderRadius="x1" backgroundColor="black" marginTop="x2" />
          <Bones borderRadius="x1" backgroundColor="black" marginTop="x2" />
          <Bones borderRadius="x1" backgroundColor="black" marginTop="x2" />
          <Bones borderRadius="x1" backgroundColor="black" marginTop="x2" />
          <Bones
            borderRadius="x1"
            backgroundColor="black"
            marginTop="x2"
            marginBottom="x2"
          />
        </Box>
        <Button
          styleType="gentleLargeReverse"
          disabled
          display="block"
        ></Button>
      </Box>
    </Tile>
  </Box>
);
